const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'
const ZERO_BYTES96 =
    '0x000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000'
const ZERO_BYTES32 = '0x0000000000000000000000000000000000000000000000000000000000000000'
const ZERO_BYTES4 = '0x00000000'
const ZERO_BYTES = '0x'

module.exports = {
    ZERO_ADDRESS,
    ZERO_BYTES96,
    ZERO_BYTES32,
    ZERO_BYTES4,
    ZERO_BYTES
}
